import { useMemo, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PRODUCTS from "./productsList";
import "./ProductGallery.css";

const TABS = ["All", "Tã Dán", "Tã Quần", "Newborn"];

export default function ProductGallery() {
  useEffect(() => {
    document.title = "Sản Phẩm Rumi";
  }, []);

  const location = useLocation();
  // nếu có cat trong state thì set active tab tương ứng
  const initialCat = location.state?.cat || "All";

  const [active, setActive] = useState(initialCat);

  const navigate = useNavigate();

  const shown = useMemo(
    () =>
      active === "All" ? PRODUCTS : PRODUCTS.filter((p) => p.cat === active),
    [active]
  );

  return (
    <section className="pg">
      <img
        src="/images/product/sp_back.jpg"
        alt="background"
        className="w-100"
      />
      <h2 className="pg-title">Sản Phẩm của Rumi</h2>

      {/* Danh sách nút filter */}
      <div className="pg-tabs" role="tablist" aria-label="Filter products">
        {TABS.map((t) => (
          <button
            key={t}
            role="tab"
            aria-selected={active === t}
            className={`pg-tab ${active === t ? "is-active" : ""}`}
            onClick={() => setActive(t)}
          >
            {t.toUpperCase()}
          </button>
        ))}
      </div>

      <div className="pg-grid">
        {shown.map((p) => (
          <article
            onClick={() => navigate(`/products/${p.id}`)}
            className="pg-item"
            key={p.id}
          >
            <div className="pg-thumb">
              <img src={p.img[0]} alt={p.title} loading="lazy" />
            </div>
            <h3 className="pg-name">{p.title}</h3>
            <div className="pg-price">
              <span className="pg-gia">Order: </span>
              <a
                href="https://shopee.vn/tabimrumivietnam"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/images/shopee.png"
                  alt="shopee"
                  className="buy-icon"
                />
              </a>
              <a
                href="https://www.tiktok.com/@tabimrumi"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/images/tiktok1.png"
                  alt="shopee"
                  className="buy-icon tiktok"
                />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
